import { Box } from '@mui/system';

export function UniqueEnvironment() {
  // React does not understand VITE environment variables, so we need the ts-ignore
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const branchName = import.meta.env.VITE_BRANCH_NAME;

  console.log('branchName', branchName);

  if (!branchName) {
    return undefined;
  }

  // Make a centered text with material ui
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '20px',
        fontWeight: 'bold',
        py: '8px',
        backgroundColor: 'black',
        color: 'white',
      }}
    >
      {branchName}
    </Box>
  );
}
